<template>
  <header class="ex-header-wrapper">
    <div>
    </div>
    <div>
      <button @click="signOut()" style="color: #c7c5d8;">Sign out</button>
    </div>
  </header>
</template>

<script>
export default {
  name: 'ex-header',
  methods: {
    signOut () {
      this.$store.dispatch('authModule/signOut')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/header/Header.vue